import { render } from "./ExclamationCircle.vue?vue&type=template&id=45b95572"
const script = {}

import exportComponent from "/var/www/tmulag_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__